import styled from 'styled-components'
import { sizes } from '../../util'

export const InfoContainer = styled.div`
  flex: 1;
  padding: 1rem 4rem 4rem;

  @media (max-width: ${sizes.large}) {
    padding: 1rem 2rem 4rem;
  }
  @media (max-width: ${sizes.medium}) {
    padding: 1rem 4rem 4rem;
  }
  @media (max-width: ${sizes.small}) {
    padding: 1rem 2rem 4rem;
  }
`

export const Right = styled.div`
  width: 50%;
  margin-left: 50%;
  @media (max-width: ${sizes.medium}) {
    margin: 0;
    width: 100%;
  }
`
export const Left = styled.div`
  position: fixed;
  will-change: transform;
  left: 0;
  top: 0;
  bottom: 0;
  width: 50vw;
  @media (max-width: ${sizes.medium}) {
    position: static;
    width: 100vw;
  }
`

export const MapWrapper = styled.div`
  width: 100%;
  height: 100vh;
  @media (max-width: ${sizes.medium}) {
    height: 50vh;
  }
`

export const MarkerWrapper = styled.div`
  position: relative;
  background: ${props => props.theme.colorText};
  color: white;
  font-size: 0.75rem;
  height: 1.25rem;
  width: 1.25rem;
  border-radius: 100%;
  &:after {
    position: absolute;
    top: 50%;
    left: 50%;
    transform:translate(-50%,-50%);
    content: '${props => props.text}';
  }
`

export const Title = styled.h1`
  margin: 0;
  margin-bottom: 0.5rem;
  font-size: 3rem;
  line-height: 1.1;
  /* padding: 3rem 4rem 0; */
  font-weight: 300;
  @media (max-width: ${sizes.medium}) {
    font-size: 2.5rem;
    /* padding: 3rem 2rem 0; */
  }
  @media (max-width: ${sizes.small}) {
    font-size: 2rem;
  }
`
export const Subtitle = styled.h2`
  margin: 0;
  margin-bottom: 1rem;
  font-size: 1.25rem;
  font-weight: 600;
  color: ${props => props.theme.colorText};
  text-transform: uppercase;
  letter-spacing: 0.02em;
`
export const Reception = styled.div`
  background: ${props => props.theme.colorText};
  padding: 1rem;
  margin: 2rem -1rem 0rem;
  color: white;
  h3 {
    font-size: 1.25rem;
    margin: 0;
    font-weight: 600;
  }
  p {
    font-size: 1.25rem;
    margin: 0;
  }
`
export const Description = styled.p`
  font-size: 1rem;
  line-height: 1.3;
  margin-bottom: 1rem;
`
export const Divider = styled.hr`
  margin: 1.5rem 0;
`
export const PlaceName = styled.p`
  margin: 2rem 0 0.35rem;
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0.01em;
`
export const PlaceBuilding = styled.p`
  margin: 0;
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.02em;
`
export const PlaceAddress = styled.p`
  margin: 0 0 0.35rem;
  font-size: 1rem;
`
export const PlaceHours = styled.p`
  margin: 0 0 1rem;
  font-size: 1rem;
`
export const Link = styled.a`
  color: ${props => props.theme.color};
  text-decoration: underline;
`
export const NameLink = styled.li`
  margin-bottom: 0.5rem;
  font-size: 1rem;
  color: ${props => (props.hasDetail ? props.theme.color : 'initial')};
  text-decoration: ${props => (props.hasDetail ? 'underline' : '')};
`
export const Back = styled.button`
  height: 5rem;
  width: 13rem;
  background: transparent;
  border: none;
  position: fixed;
  will-change: transform;
  z-index: 1;

  > * {
    pointer-events: none;
  }

  &:hover {
    opacity: 0.5;
    cursor: pointer;
  }

  @media (min-width: ${sizes.medium}) {
    height: 6rem;
    width: 16rem;
  }
`
export const Loading = styled.p`
  color: ${props => props.theme.color};
`
export const HideDesktop = styled.div`
  margin-top: 2rem;
  display: block;
  @media (min-width: ${sizes.medium}) {
    display: none;
  }
`
export const HideMobile = styled.div`
  margin-top: 2rem;
  display: none;
  @media (min-width: ${sizes.medium}) {
    display: block;
  }
`

export const Box = styled.div`
  width: 100%;
  background: white;
  max-width: ${({ width }) => (width === 'full' ? 'auto' : '30rem')};
  color: ${({ theme }) => theme.colorText};
  align-self: ${({ align }) => align};
  ${({ shadow }) => shadow && 'box-shadow: 0 0 1.5rem rgba(0,0,0,0.15);'}
`

export const Wrapper = styled.div`
  counter-reset: section;
  max-width: ${({ width }) => (width === 'full' ? 'auto' : '100rem')};
  /* margin: ${({ width }) => (width === 'full' ? '0 auto' : '1rem')}; */
  margin: 0 auto;
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  background: ${({ bg }) => bg || 'transparent'};
  pointer-events: none;
  * {
    pointer-events: initial;
  }
  padding: ${({ width }) => (width === 'full' ? '0' : '0 4rem')};

  @media (max-width: ${sizes.large}) {
    padding: ${({ width }) => (width === 'full' ? '0' : '0 2rem')};
  }
  @media (max-width: ${sizes.medium}) {
    padding: ${({ width }) => (width === 'full' ? '0' : '0 2rem')};
  }
  @media (max-width: ${sizes.small}) {
    padding: ${({ width }) => (width === 'full' ? '0' : '0 1rem')};
  }
`

export const Text = styled.p`
  font-size: ${({ size }) => (size === 'big' ? '2.75rem' : '1.5rem')};
  line-height: 1.3;
  padding: ${({ size }) => (size === 'big' ? '2rem 4rem' : '2rem 4rem 4rem')};
  ${({ align }) => align && `text-align: ${align}`}
  bold {
    font-weight: 600;
  }
  @media (max-width: ${sizes.medium}) {
    font-size: ${({ size }) => (size === 'big' ? '1.75rem' : '1.25rem')};
    padding: ${({ size }) => (size === 'big' ? '2rem 2rem' : '2rem 2rem 2rem')};
  }
  @media (max-width: ${sizes.small}) {
    font-size: ${({ size }) => (size === 'big' ? '1.5rem' : '1rem')};
  }
`
export const Tag = styled.p`
  font-size: 4rem;
  line-height: 1.1;
  /* padding: 3rem 4rem 0; */
  font-weight: 300;
  @media (max-width: ${sizes.medium}) {
    font-size: 3.5rem;
    /* padding: 3rem 2rem 0; */
  }
  @media (max-width: ${sizes.small}) {
    font-size: 2.5rem;
  }
`
export const Top = styled.div`
  font-size: ${({ size }) => (size === 'big' ? '2.75rem' : '0.75rem')};
  font-weight: ${({ size }) => (size === 'big' ? 400 : 600)};
  text-transform: ${({ size }) => (size === 'big' ? 'none' : 'uppercase')};
  letter-spacing: 0.03em;
  line-height: 1.3;
  padding: ${({ size }) => (size === 'big' ? '2rem 4rem 1rem' : '1rem 4rem')};
  border-bottom: 1px solid;
  transform: translateY(-1px);
  background: white;
  ${({ bt }) =>
    bt &&
    `
    border-top: 1px solid;
    transform: translateY(-1px);
  `};
  @media (max-width: ${sizes.large}) {
    padding: ${({ size }) => (size === 'big' ? '2rem 2rem 1rem' : '1rem 2rem')};
  }
  @media (max-width: ${sizes.medium}) {
    font-size: ${({ size }) => (size === 'big' ? '2rem' : '0.75rem')};
    padding: ${({ size }) => (size === 'big' ? '2rem 4rem 1rem' : '1rem 4rem')};
  }
  @media (max-width: ${sizes.small}) {
    padding: ${({ size }) => (size === 'big' ? '2rem 2rem 1rem' : '1rem 2rem')};
  }
`

export const LocationLi = styled.li`
  section {
    padding: 1rem 4rem 2rem;
    line-height: 1.3;

    @media (max-width: ${sizes.large}) {
      padding: 1rem 2rem 2rem;
    }
    @media (max-width: ${sizes.medium}) {
      padding: 1rem 4rem 2rem;
    }
    @media (max-width: ${sizes.small}) {
      padding: 1rem 2rem 2rem;
    }
  }
  ${Top} {
    border-top: 1px solid;
    position: relative;
    &::before {
      position: absolute;
      /* left: 0; */
      transform: translateX(-100%);
      counter-increment: section;
      content: counter(section) '.';
      padding-right: 0.5em;
    }
  }
`

export const LocationUl = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  position: relative;
  li:first-child {
    ${Top} {
      border-top: none;
    }
  }
`

export const ProgramHeader = styled.h4`
  font-size: 0.75rem;
`
